"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgCall = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_CALL", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M5.89 10.055c2.1 2.1 3.98 3.227 5.22 3.812.265.124.746.121 1.252-.385l.256-.256c.381-.381.686-.73.928-1.034l-2.229-1.92-.107.056-.031.017c-.03.017-.104.057-.193.098-.174.081-.536.23-1.012.226-.592-.004-1.117-.221-1.554-.484-.447-.269-.927-.661-1.463-1.197-.536-.537-.928-1.016-1.197-1.464-.263-.436-.48-.962-.484-1.553A2.357 2.357 0 0 1 5.5 4.959a3.173 3.173 0 0 1 .116-.224l.055-.108L3.753 2.4c-.304.241-.653.546-1.034.927l-.256.257c-.506.506-.51.986-.385 1.25.584 1.24 1.71 3.121 3.812 5.222ZM1.048 2.168l.257-.256c.91-.91 1.692-1.47 2.205-1.788.37-.23.83-.128 1.112.2l3.014 3.5c.266.308.317.748.129 1.112l-.37.718-.03.054a.493.493 0 0 0-.083.235c.002.213.162.685 1.098 1.621.937.937 1.409 1.097 1.621 1.099.084 0 .16-.042.235-.083l.055-.03.718-.37a1.001 1.001 0 0 1 1.112.129l3.5 3.014c.327.282.43.742.2 1.112-.318.513-.878 1.295-1.788 2.205l-.257.256c-.951.952-2.32 1.357-3.53.786-1.434-.675-3.507-1.931-5.78-4.204C2.194 9.205.938 7.133.262 5.698c-.57-1.21-.165-2.578.786-3.53Z" }))); };
exports.default = SvgCall;
